<template>
  <div class="py-6 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4 border shadow-sm">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6 class="mb-0">客服對話大廳 (Chat Lobby)</h6>
            <button class="btn btn-primary btn-sm" @click="fetchLobby">
              <i class="fas fa-sync-alt"></i> 刷新
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4"
                    >
                      客戶
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      最新訊息
                    </th>
                    <th
                      class="text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 pe-4"
                    >
                      時間
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading && chats.length === 0">
                    <td colspan="4" class="text-center py-5">
                      <div
                        class="spinner-border text-primary"
                        role="status"
                      ></div>
                    </td>
                  </tr>
                  <tr v-if="!loading && chats.length === 0">
                    <td colspan="4" class="text-center py-5 text-muted">
                      <i class="fas fa-inbox fa-3x mb-3 text-gray-200"></i>
                      <p>目前沒有活躍的對話</p>
                    </td>
                  </tr>
                  <tr
                    v-for="chat in chats"
                    :key="chat.order_id"
                    class="cursor-pointer transition-colors hover:bg-gray-50 bg-white border-bottom"
                    :class="{ 'bg-blue-50': chat.unread_count > 0 }"
                    @click="$router.push(`/orders/${chat.order_number}`)"
                  >
                    <!-- User & Status -->
                    <td class="ps-4 py-3" style="width: 250px">
                      <div class="d-flex align-items-center">
                        <div
                          class="avatar rounded-circle me-3 bg-gradient-dark text-white d-flex align-items-center justify-content-center text-sm font-bold shadow-sm"
                          style="width: 40px; height: 40px"
                        >
                          {{
                            chat.buyer_name
                              ? chat.buyer_name.charAt(0).toUpperCase()
                              : "U"
                          }}
                        </div>
                        <div class="d-flex flex-column">
                          <h6 class="mb-0 text-sm font-weight-bold text-dark">
                            {{ chat.buyer_name || "Guest" }}
                          </h6>
                          <span class="text-xs text-secondary font-monospace"
                            >#{{ chat.order_number }}</span
                          >
                        </div>
                      </div>
                    </td>

                    <!-- Message Preview -->
                    <td class="py-3">
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mb-1">
                          <span
                            v-if="chat.unread_count > 0"
                            class="badge bg-danger rounded-pill me-2"
                          >
                            {{ chat.unread_count }} new
                          </span>
                          <span
                            class="text-xs text-muted font-weight-bold"
                            v-else
                          >
                            {{ chat.last_message_is_self ? "You: " : "" }}
                          </span>
                        </div>
                        <p
                          class="text-sm text-secondary mb-0 text-truncate"
                          style="max-width: 400px"
                        >
                          <span v-if="chat.last_message_type === 'image'"
                            ><i class="fas fa-image text-xs me-1"></i>
                            傳送了圖片</span
                          >
                          <span v-else-if="chat.last_message_type === 'file'"
                            ><i class="fas fa-file text-xs me-1"></i>
                            傳送了檔案</span
                          >
                          <span v-else>{{ chat.last_message }}</span>
                        </p>
                      </div>
                    </td>

                    <!-- Time -->
                    <td
                      class="align-middle text-end pe-4 py-3"
                      style="width: 150px"
                    >
                      <span class="text-secondary text-xs font-weight-bold">{{
                        formatDate(chat.last_message_at)
                      }}</span>
                      <div class="text-xs text-muted mt-1">
                        <i class="fas fa-chevron-right"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "ChatLobby",
  data() {
    return {
      chats: [],
      loading: false,
      timer: null,
    };
  },
  mounted() {
    this.fetchLobby();
    this.timer = setInterval(this.fetchLobby, 10000); // Refresh every 10s
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async fetchLobby() {
      // Don't set global loading on background refresh
      //   this.loading = true;
      try {
        const res = await request.get("/api/admin/chat/lobby");
        if (res.data.success) {
          this.chats = res.data.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    },
  },
};
</script>

<style scoped>
.bg-primary-subtle {
  background-color: #e3f2fd;
}
</style>
